<app-navbar-style-two></app-navbar-style-two>

<!-- Start Page Title Area -->
<!-- <div class="page-title-area" *ngFor="let Content of pageTitle;" style="background-image: url({{Content.bgImage}});">
    <h1>{{Content.title}}</h1>
    <ul>
        <li><a routerLink="/">Home</a></li>
        <li>{{Content.title}}</li>
    </ul>
</div> -->
<!-- End Page Title Area -->

<!-- Start Wishlist Area -->
<!-- <section class="wishlist-area ptb-100">
    <div class="container">
        <form>
            <div class="wishlist-table table-responsive">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Product</th>
                            <th scope="col">Name</th>
                            <th scope="col">Unit Price</th>
                            <th scope="col">Stock Status</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td class="product-thumbnail">
                                <a routerLink="/simple-product"><img src="assets/img/products/products4.jpg" alt="item"></a>
                            </td>

                            <td class="product-name">
                                <a routerLink="/simple-product">Ergonomic Desk Sofa</a>
                            </td>

                            <td class="product-price">
                                <span class="unit-amount">$150.00</span>
                            </td>

                            <td class="product-stock-status">
                                <span class="in-stock"><i class='bx bx-check-circle'></i> In Stock</span>
                            </td>

                            <td class="product-subtotal">
                                <a routerLink="/cart" class="default-btn"><i class="bx bx-shopping-bag"></i> ADD TO CART</a>
                                <a routerLink="/wishlist" class="remove"><i class='bx bx-trash'></i></a>
                            </td>
                        </tr>

                        <tr>
                            <td class="product-thumbnail">
                                <a routerLink="/simple-product"><img src="assets/img/products/products5.jpg" alt="item"></a>
                            </td>

                            <td class="product-name">
                                <a routerLink="/simple-product">Office Desk Sofa</a>
                            </td>

                            <td class="product-price">
                                <span class="unit-amount">$199.00</span>
                            </td>

                            <td class="product-stock-status">
                                <span class="in-stock"><i class='bx bx-check-circle'></i> In Stock</span>
                            </td>

                            <td class="product-subtotal">
                                <a routerLink="/cart" class="default-btn"><i class="bx bx-shopping-bag"></i> ADD TO CART</a>
                                <a routerLink="/wishlist" class="remove"><i class='bx bx-trash'></i></a>
                            </td>
                        </tr>

                        <tr>
                            <td class="product-thumbnail">
                                <a routerLink="/simple-product"><img src="assets/img/products/products6.jpg" alt="item"></a>
                            </td>

                            <td class="product-name">
                                <a routerLink="/simple-product">Swivel Sofa</a>
                            </td>

                            <td class="product-price">
                                <span class="unit-amount">$233.99</span>
                            </td>

                            <td class="product-stock-status">
                                <span class="in-stock"><i class='bx bx-check-circle'></i> In Stock</span>
                            </td>

                            <td class="product-subtotal">
                                <a routerLink="/cart" class="default-btn"><i class="bx bx-shopping-bag"></i> ADD TO CART</a>
                                <a routerLink="/wishlist" class="remove"><i class='bx bx-trash'></i></a>
                            </td>
                        </tr>

                        <tr>
                            <td class="product-thumbnail">
                                <a routerLink="/simple-product"><img src="assets/img/products/products7.jpg" alt="item"></a>
                            </td>

                            <td class="product-name">
                                <a routerLink="/simple-product">Home Alisa Sofa</a>
                            </td>

                            <td class="product-price">
                                <span class="unit-amount">$223.00</span>
                            </td>

                            <td class="product-stock-status">
                                <span class="out-stock"><i class='bx bx-x'></i> Out of Stock</span>
                            </td>

                            <td class="product-subtotal">
                                <a routerLink="/cart" class="default-btn"><i class="bx bx-shopping-bag"></i> ADD TO CART</a>
                                <a routerLink="/wishlist" class="remove"><i class='bx bx-trash'></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form>
    </div>
</section> -->
<!-- End Wishlist Area -->





<!-- <app-navbar-style-two></app-navbar-style-two> -->

<!-- Start Page Title Area -->
<!-- <div class="page-title-area" *ngFor="let Content of pageTitle;" style="background-image: url({{Content.bgImage}});">
    <h1>{{Content.title}}</h1>
    <ul>
        <li><a routerLink="/">Home</a></li>
        <li>{{Content.title}}</li>
    </ul>
</div> -->
<!-- End Page Title Area -->

<!-- Start Wishlist Area -->
<section class="wishlist-area ptb-100">
    <div class="container">
        <!-- Wishlist items table -->
       <div class="wishlist-grid" *ngIf="isLoggedIn && wishlist.length > 0">

    <div class="wishlist-card"
         *ngFor="let item of wishlist">

        <div class="wishlist-image">

            <img [src]="item.image"
                 [alt]="item.title"
                 (error)="$event.target.src='assets/img/project1.jpg'">

            <button class="remove-btn"
                    (click)="removeFromWishlist(item)">
                <i class='bx bx-trash'></i>
            </button>

        </div>

        <div class="wishlist-content">

            <h3>{{ item.title }}</h3>

            <div class="wishlist-price">
                ₹{{ item.price }}
            </div>

            <div class="wishlist-stock">

                <span class="in-stock"
                      *ngIf="item.stock > 0">

                    <i class='bx bx-check-circle'></i>
                    In Stock

                </span>

                <span class="out-stock"
                      *ngIf="item.stock <= 0">

                    <i class='bx bx-x-circle'></i>
                    Out Of Stock

                </span>

            </div>

            <button class="cart-btn"
                    (click)="addWishlistItemToCart(item)"
                    [disabled]="item.stock <= 0">

                <i class='bx bx-shopping-bag'></i>
                Add To Cart

            </button>

        </div>

    </div>

</div>

        <!-- Empty Wishlist State -->
        <div *ngIf="!isLoggedIn || wishlist.length === 0" class="text-center py-5">
            <div class="mb-4">
                <i class='bx bx-heart-circle' style="font-size: 80px; color: #ff4d4f;"></i>
            </div>
            <h3>Your Wishlist is Empty</h3>
            <p class="text-muted" *ngIf="isLoggedIn">Explore Sangeetha Toys products and save your favorites here!</p>
            <p class="text-muted" *ngIf="!isLoggedIn">Please log in to manage your wishlist.</p>
            <a [routerLink]="isLoggedIn ? '/menu' : '/profile-authentication'" class="viewbtn mt-3 text-white">
                {{ isLoggedIn ? 'View Menu / Shop' : 'Log In' }}
            </a>
        </div>
    </div>
</section>
<!-- End Wishlist Area -->
